"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _color = _interopRequireDefault(require("../../constants/color"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _cardContent = _interopRequireDefault(require("./cardContent"));

var _cardFooter = _interopRequireDefault(require("./cardFooter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Card = function Card(_ref) {
  var _styles;

  var children = _ref.children,
      clickable = _ref.clickable,
      backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      onClick = _ref.onClick,
      fullHeight = _ref.fullHeight,
      small = _ref.small,
      props = _objectWithoutProperties(_ref, ["children", "clickable", "backgroundColor", "backgroundImage", "onClick", "fullHeight", "small"]);

  var styles = (_styles = {
    'co-card': true,
    'co-card--clickable': clickable
  }, _defineProperty(_styles, backgroundColor, backgroundColor), _defineProperty(_styles, 'co-card__background-image', backgroundImage), _defineProperty(_styles, "co-card__background-image--".concat(backgroundImage), backgroundImage), _styles); // BEWARE: Possible unknown used global modifiers, leave allowedModifiers open to any spread prop

  var allowedModifiers = _objectSpread({
    fullHeight: fullHeight,
    small: small
  }, props);

  return _react.default.createElement(_styler.default, {
    classNames: styles,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles,
      tabIndex: clickable ? 0 : null,
      onClick: onClick
    }, (0, _getNativeProps.default)(props)), children);
  });
};

Card.defaultProps = {
  onClick: function onClick() {}
};
Card.propTypes = {
  /** {---} Sequence of:
      @@<Header>@@ (optional, max: 1),
      @@<Card.Content>@@ (required, min: 1),
      @@<DismissIcon>@@ (optional, max: 1),
      @@<Card.Footer>@@ (optional, max: 1)
  */
  children: _propTypes.any.isRequired,
  clickable: _propTypes.bool,
  small: _propTypes.bool,
  fullHeight: _propTypes.bool,

  /** {const} Only accepts Color.background.gray[100] */
  backgroundColor: (0, _propTypes.oneOf)([_color.default.background.gray[100]]),
  backgroundImage: _propTypes.string,
  onClick: _propTypes.func
};
Card.Content = _cardContent.default;
Card.Footer = _cardFooter.default;
var _default = Card;
exports.default = _default;
Card.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Card",
  "props": {
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of:\n      @@<Header>@@ (optional, max: 1),\n      @@<Card.Content>@@ (required, min: 1),\n      @@<DismissIcon>@@ (optional, max: 1),\n      @@<Card.Footer>@@ (optional, max: 1)"
    },
    "clickable": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "fullHeight": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "backgroundColor": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "Color.background.gray[100]",
          "computed": true
        }]
      },
      "required": false,
      "description": "{const} Only accepts Color.background.gray[100]"
    },
    "backgroundImage": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};